import type { QuestionRequirementsRichText } from '@wx-weiqi/contracts';

export function QuestionRequirementsText({
  text,
  richText,
  fallback,
}: {
  readonly text?: string | null;
  readonly richText?: QuestionRequirementsRichText | null;
  readonly fallback: string;
}) {
  if (!text?.trim()) return <>{fallback}</>;
  if (!richText?.length || richText.map((run) => run.text).join('') !== text) return <>{text}</>;
  return (
    <>
      {richText.map((run, index) => (
        <span
          key={index}
          style={{
            fontWeight: run.bold ? 700 : 400,
            color: run.color === 'RED' ? '#b53a32' : '#000000',
          }}
        >
          {run.text}
        </span>
      ))}
    </>
  );
}
